import { render, staticRenderFns } from "./SchoolOfCreativityDetail.vue?vue&type=template&id=6695b3e8&scoped=true"
import script from "./SchoolOfCreativityDetail.vue?vue&type=script&lang=js"
export * from "./SchoolOfCreativityDetail.vue?vue&type=script&lang=js"
import style0 from "./SchoolOfCreativityDetail.vue?vue&type=style&index=0&id=6695b3e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6695b3e8",
  null
  
)

export default component.exports